import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import Modal from 'react-bootstrap/Modal';
import ButtonTheme from "../ThemeButton/ThemeButton";
import { Col, Row } from 'react-bootstrap';

export default function Deleteconfirmation({ openModal, acceptFunction, rejectFunction }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    setOpen(openModal)
  }, [openModal])

  let handleClose = () => {
    setOpen(false)
  }

  let accept = () => {
    acceptFunction()
    handleClose()
  }

  let reject = () => {
    rejectFunction()
    handleClose()
  }

  return <Modal show={open} onHide={reject}>
  <Modal.Header closeButton>
    <Modal.Title>Delete</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <div style={{ color: '#555555' }}>
      Are you sure to delete?
    </div>
    <Row>
      <Col md='auto'>
        <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={reject}>
          Cancel
        </ButtonTheme>
      </Col>
      <Col md='auto'>
        <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={accept}>
          Delete
        </ButtonTheme>
      </Col>
    </Row>
  </Modal.Body>
  </Modal>
}
